import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'Is this safe if I have high blood pressure?',
    answer: "Yes! The ingredients are whole-food based (turmeric, ginger, etc.). However, always consult your doctor before starting any new protocol—especially if you're on medication."
  }, {
    question: 'Is it easy to follow?',
    answer: 'Absolutely. The entire ritual takes 5 minutes each morning. Everything is available at your local grocery store for under $15.'
  }, {
    question: 'How soon will I get the book?',
    answer: "Instantly! The moment your payment processes, you'll receive a download link via email. You can start reading in 60 seconds."
  }, {
    question: "What if I don't see results?",
    answer: 'Then you get your money back—100% refund within 7 days, no questions asked. All the risk is on me.'
  }];
  return <section className="py-20 bg-white" data-id="element-75">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-76">
        <h2 className="text-3xl font-bold text-center text-stone-900 mb-12" data-id="element-77">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-78">
          {faqs.map((faq, index) => <div key={index} className="border border-stone-200 rounded-lg overflow-hidden" data-id="element-79">
              <button className="w-full flex items-center justify-between p-6 text-left bg-stone-50 hover:bg-stone-100 transition-colors cursor-pointer" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-80">
                <span className="font-bold text-stone-900 text-lg pr-4" data-id="element-81">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-stone-500 flex-shrink-0" data-id="element-82" /> : <ChevronDown className="w-5 h-5 text-stone-500 flex-shrink-0" data-id="element-83" />}
              </button>

              {openIndex === index && <div className="p-6 bg-white border-t border-stone-200" data-id="element-84">
                  <p className="text-stone-600 leading-relaxed" data-id="element-85">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}